export const SEVERITY_BANDS = [
  { key: 'critical', min: 70, color: 'var(--threat-critical)', labelKey: 'common.severity.critical' },
  { key: 'high',     min: 40, color: 'var(--threat-high)',     labelKey: 'common.severity.high' },
  { key: 'medium',   min: 20, color: 'var(--threat-medium)',   labelKey: 'common.severity.medium' },
  { key: 'low',      min: 0,  color: 'var(--threat-low)',      labelKey: 'common.severity.low' },
];

export function bandOf(score) {
  if (score == null) return 'none';
  if (score >= 70) return 'critical';
  if (score >= 40) return 'high';
  if (score >= 20) return 'medium';
  return 'low';
}

export function computeRiskDist(scans) {
  const d = { critical: 0, high: 0, medium: 0, low: 0, none: 0 };
  scans.forEach(s => {
    d[bandOf(s?.risk_score)]++;
  });
  return d;
}
